import {NotifierService} from "./notifierService/notifier.service";
import { Injectable } from '@angular/core';
import { OrientationModelService } from '../core/models/orientation-model.service';
import { AppServices } from "app/app.services";
import {UtilityScripts} from '../helpers/utility-scripts'
import { AppConstants } from "app/core/vo/app-constants";
import { TrackingManager } from "app/core/tracking/tracking-manager";
import { CMI5 } from "app/core/tracking/cmi5";

@Injectable()
export class OrientationService extends NotifierService  {  
    private  PRESENTAION_MENU:String = 'presentationMenu';
    private  PROGRESS_BAR:String = 'progressBar';
    private isOrientationCompleted:Boolean = false;
    public stepIndex:number = 0;

    public skippableOrientation:Boolean = false;
    public enabledNext: Boolean = false;
    
    constructor( private orientationModel: OrientationModelService,
        public appService:AppServices
    ) {
        super();
    }
    public initialize()
    {
        console.log('this.orientationModel.steps   :',this.orientationModel.steps);
        /* Below code is to remove the orientation for Document dropdown as per PT platform branding guideline */
        if(TrackingManager.instance.trackingObj instanceof CMI5){
            let CMI5obj = TrackingManager.instance.trackingObj as CMI5;
            if(CMI5obj.getLaunchURLVO().branding_profile == AppConstants.PLATFORM){
                let docIndex = -1;
                this.orientationModel.steps.forEach((step, index) => {
                    if(step.anchorId.toLowerCase() == "documenttab"){
                        console.log(index);
                        docIndex = index;
                    }
                })
                if(docIndex != -1)
                    this.orientationModel.steps.splice(docIndex,1);
            }
        }
    }
    
    public end() {   
        const _iOSDevice = navigator.platform.indexOf('MacIntel') != -1;
        this.stepIndex  = 0 ;
        this.isOrientationCompleted = true;
        if(window.innerWidth <= 1024 ){
            if((UtilityScripts.isMobileDevice() ||  _iOSDevice )) {
                this.appService.toggleLeftMenu('page-inner-wrap toggled');
            }
            else {
                this.appService.toggleLeftMenu('page-inner-wrap');
            }
        }
    }
    
    public get OrientationCompleted(): Boolean
    {
        return this.isOrientationCompleted;
    }
    public set OrientationCompleted(val: Boolean)
    {
         this.isOrientationCompleted = val;
    }
}